import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';

const HeroContainer = ({
  hero,
  heroStoreDataKey,
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    heroData={hero[`${heroStoreDataKey}`]}
    {...props}
  />
);

const mapStateToProps = ({ content }) => ({
  // TODO: change to cards: state.content.cards,
  hero: R.propOr({}, 'hero', content),
});

HeroContainer.propTypes = {
  hero: PropTypes.objectOf(PropTypes.shape({
    title: PropTypes.string,
    label: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
  })).isRequired,
  heroStoreDataKey: PropTypes.string.isRequired,
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(HeroContainer);
